import { useGetCall, useLazyGetCallWithURL } from 'common/api/useApiCall';
import { URLS } from 'constants/URL';
import {
  adaptInfraDeploymentResponse,
  adaptInfraResourcesResponse,
  adaptSqsResourceResponse,
  adaptVpcResourceResponse,
} from './responseAdapters';
import { useEffect } from 'react';

export const useTenantInfraDetails = ({ tenant }) => {
  const { domain, metadata, infraDeploymentId, _id: id } = tenant;
  const { infraInfo = {} as any } = metadata || {};
  const {
    response: {
      eksCloudResourceUrl,
      ecrepo,
      vpcCloudResourceUrl,
      cloudLocationId,
    },
  } = useGetCall(
    `${URLS.fetchInfraDeployementDetails}${id}`,
    adaptInfraDeploymentResponse,
  );
  const { response: ec2InstanceTailscaleIp, postData } = useLazyGetCallWithURL(
    adaptInfraResourcesResponse,
  );

  const { response: sqsResource, postData: postSqsData } =
    useLazyGetCallWithURL(adaptSqsResourceResponse);

  const { response: vpcResource, postData: postVpcData } =
    useLazyGetCallWithURL(adaptVpcResourceResponse);

  useEffect(() => {
    if (ecrepo) {
      const queryParams = new URLSearchParams({
        'tenant-id': id,
        'tenant-domain': domain,
        'fetch-from-mothersite': 'true',
        'cloud-resource-url': ecrepo,
      });
      postData(`${URLS.fetchInfraResourceDetails}${queryParams.toString()}`);
    }
  }, [ecrepo, id, domain]);

  useEffect(() => {
    if (vpcCloudResourceUrl) {
      const queryParams = new URLSearchParams({
        'tenant-id': id,
        'tenant-domain': domain,
        'fetch-from-mothersite': 'true',
        'cloud-resource-url': vpcCloudResourceUrl,
      });
      postVpcData(`${URLS.fetchInfraResourceDetails}${queryParams.toString()}`);
    }
  }, [vpcCloudResourceUrl, id, domain]);

  useEffect(() => {
    if (id && domain && cloudLocationId) {
      const resourceType = cloudLocationId.toLowerCase().includes('azure')
        ? 'AZURE_AQS'
        : 'AWS_SQS';

      const queryParams = new URLSearchParams({
        'tenant-id': id,
        'tenant-domain': domain,
        'resource-type': resourceType,
      });
      postSqsData(`${URLS.fetchInfraResourceDetails}${queryParams.toString()}`);
    }
  }, [id, domain, cloudLocationId]);

  return {
    infraInfo,
    eksCloudResourceUrl,
    domain,
    ec2InstanceTailscaleIp,
    sqsResource,
    vpcResource,
  };
};
